import en from "../_translation/en/translation.json";
import ja from "../_translation/ja/translation.json";
import ko from "../_translation/ko/translation.json";
import zh from "../_translation/zh/translation.json";
import ptBr from "../_translation/pt-BR/translation.json";
import compareVersions, { VERSION_DAM_463_LANGUAGE_PT_ZH } from "../cores/version";

export function getLocalResource(value) {
    switch (value) {
        case "ko":
            return ko;
        case "en":
            return en;
        case "ja":
            return ja;
        case "zh":
            return zh;
        case "pt-BR":
            return ptBr;
        default:
            return en;
    }
}

export function getLocalLngList(defaultLanguageCode) {
    const locales = [
        {
            id: 1,
            label: "English",
            value: "en",
            isDefault: 1,
        },
        {
            id: 2,
            label: "한국어",
            value: "ko",
            isDefault: 0,
        },
        {
            id: 3,
            label: "日本語",
            value: "ja",
            isDefault: 0,
        },
        {
            id: 4,
            label: "中文",
            value: "zh",
            isDefault: 0,
            minVersion: VERSION_DAM_463_LANGUAGE_PT_ZH,
        },
        {
            id: 5,
            label: "Português",
            value: "pt-BR",
            isDefault: 0,
            minVersion: VERSION_DAM_463_LANGUAGE_PT_ZH,
        },
    ];

    return {
        locales,
        translation: getLocalResource(defaultLanguageCode),
    };
}

/**
 * Space 버전에서 지원하는 언어만 남긴다.
 *
 * getLocalLngList()는 부팅 시점(i18init)에 호출되어 결과가 localStorage에 캐싱되는데,
 * 그 시점엔 stage.version이 아직 없고 Space는 런타임에 전환될 수도 있다.
 * 따라서 목록 생성 시점이 아니라 소비 시점에 이 함수로 게이트를 적용한다. (DAM-463)
 *
 * @param {Array<{value: string, minVersion?: string}>} locales getLocalLngList()의 locales (localStorage 캐시 포함)
 * @param {string} spaceVersion stage.version
 * @returns {Array} 노출 가능한 언어 목록
 */
export function filterLocalesBySpaceVersion(locales, spaceVersion) {
    if (!Array.isArray(locales)) return [];
    return locales.filter((locale) => !locale?.minVersion || compareVersions(spaceVersion, locale.minVersion) >= 0);
}

export function getDefaultLanguage() {
    return "en";
}

export function getLocalLng(code) {
    return getLocalResource(code);
}
